(function() {
  var Router,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  exports.UsernameDropdownRouter = (function(superClass) {
    extend(UsernameDropdownRouter, superClass);

    function UsernameDropdownRouter() {
      return UsernameDropdownRouter.__super__.constructor.apply(this, arguments);
    }

    UsernameDropdownRouter.prototype.prefix = 'UsernameDropdown';

    UsernameDropdownRouter.prototype.module_name = 'UsernameDropdownRouter';

    UsernameDropdownRouter.prototype.register = function() {
      this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
      this.service('core::Services/UserService', ['$http', '$window']);
      this.controller('core::Angular/UsernameDropdown/ContactInfoController', ['$q', '$scope', '$transitions', '$uibModalInstance', 'userData', 'states', 'additionalValidation', 'UsernameDropdown.Services.UserService', '$timeout', '$window', '$ngModal']);
      this.controller('core::Angular/UsernameDropdown/BackgroundController', ['$scope', '$transitions', '$uibModalInstance', 'UsernameDropdown.Services.UserService', 'userData', 'backgroundOptions']);
      return this.controller('core::Angular/UsernameDropdown/LocaleController', ['$scope', '$transitions', '$uibModalInstance', 'userData', 'locales', 'UsernameDropdown.Services.UserService']);
    };

    return UsernameDropdownRouter;

  })(Router);

}).call(this);
